import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ONBOARDING_ROUTES } from 'src/app/shared/enums/appRoutes.enum';
import { EmailService } from 'src/app/core/services/email.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const emailGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const router = inject(Router);
  const emailService = inject(EmailService);

  return emailService.getEmail().pipe(
    map(email => {
      // Check if this is an invitation link with email in URL parameters
      const isInvited = route.queryParams['invited'] === 'true';
      const emailFromUrl = route.queryParams['email'];

      if (isInvited && emailFromUrl) {
        // Allow access for invitation links
        return true;
      }

      if (!email) {
        router.navigate([ONBOARDING_ROUTES.LOGIN]);
        return false;
      }
      return true;
    })
  );
};
